export const getQvctAnswersChoise = (state) => state.qvctAnswersChoise

